import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoItsForSection() {
  return <section className="py-12 bg-warm-900 text-warm-50" data-id="element-228">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-229">
        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-230">
          {/* YES */}
          <div data-id="element-231">
            <h3 className="text-2xl font-serif text-rose-300 mb-8 flex items-center gap-3" data-id="element-232">
              <CheckCircle2 className="w-8 h-8" data-id="element-233" />
              Esta guía ES para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-234">
              {['Trabajas un buen y aun así no te alcanza la quincena.', 'Quieres ingresos extra, pero todo te parece estafa.', 'Usas el cel todo el día pero nunca te ha pagado.', 'No quieres mostrar tu cuerpo ni hacer cosas raras.', 'No tienes inglés perfecto pero sí ganas de aprender.'].map((item, i) => <li key={i} className="flex gap-4 items-start opacity-90" data-id="element-235">
                  <span className="mt-1.5 w-2 h-2 bg-rose-400 rounded-full shrink-0" data-id="element-236"></span>
                  <span className="text-lg" data-id="element-237">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* NO */}
          <div className="bg-warm-800/50 p-8 rounded-2xl border border-warm-700" data-id="element-238">
            <h3 className="text-2xl font-serif text-warm-200 mb-8 flex items-center gap-3" data-id="element-239">
              <XCircle className="w-8 h-8" data-id="element-240" />
              NO es para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-241">
              {['Buscas hacerte millonaria en 24 horas.', 'Estás dispuesta a hacer cualquier cosa por dinero.', "Quieres un 'sistema mágico' donde no hagas nada.", 'Buscas fórmulas de cripto o apuestas.'].map((item, i) => <li key={i} className="flex gap-4 items-start opacity-70" data-id="element-242">
                  <span className="mt-1.5 w-2 h-2 bg-warm-500 rounded-full shrink-0" data-id="element-243"></span>
                  <span className="text-lg" data-id="element-244">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}